"use client";

import { useNavigate } from "react-router";
import Icon from "../components/Icon";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Container } from "react-bootstrap";

export default function CookiePolicyPage() {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Container fluid>
            <Row>
                <Col>
                    <div className="mt-4 mb-5">
                        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                            <h2 className="mb-0">Политика использования файлов Cookie</h2>
                            <button
                                className="btn btn-outline-secondary"
                                onClick={handleGoBack}
                                aria-label="Вернуться назад"
                            >
                                <Icon icon={faTimes} />
                            </button>
                        </div>

                        <div className="mb-3 text-muted">
                            <strong>Дата вступления в силу:</strong> 25.07.2026
                        </div>

                        <p>
                            Настоящая Политика использования файлов Cookie (далее — «Политика») описывает порядок использования файлов Cookie сервисом «Артефакты» (далее — «Сервис»).
                        </p>

                        <h3>1. Что такое Cookie</h3>
                        <p>
                            Cookie — это небольшие текстовые файлы, которые сохраняются браузером на устройстве Пользователя при использовании Сервиса.
                        </p>
                        <p>
                            Cookie позволяют обеспечить корректную работу отдельных функций Сервиса.
                        </p>

                        <h3>2. Какие Cookie используются</h3>
                        <p>Сервис использует только технически необходимые файлы Cookie.</p>
                        <p>В частности, используются:</p>
                        <ul>
                            <li>Cookies сессии пользователя — для поддержания авторизации и корректной работы учетной записи;</li>
                            <li>Cookies, содержащие CSRF-токен, — для защиты Сервиса от межсайтовой подделки запросов (Cross-Site Request Forgery).</li>
                        </ul>
                        <p>
                            Сервис <strong>не использует</strong> Cookie:
                        </p>
                        <ul>
                            <li>для показа рекламы;</li>
                            <li>для отслеживания действий пользователя на сторонних сайтах;</li>
                            <li>для создания маркетинговых профилей;</li>
                            <li>для передачи данных рекламным сетям.</li>
                        </ul>

                        <h3>3. Цели использования Cookie</h3>
                        <p>Cookies используются исключительно для:</p>
                        <ul>
                            <li>обеспечения безопасной авторизации;</li>
                            <li>поддержания пользовательской сессии;</li>
                            <li>защиты запросов к Сервису от CSRF-атак;</li>
                            <li>обеспечения корректной работы веб-интерфейса.</li>
                        </ul>

                        <h3>4. Передача данных третьим лицам</h3>
                        <p>
                            Информация, содержащаяся в используемых Cookie, не продается и не передается третьим лицам, за исключением случаев, предусмотренных законодательством Российской Федерации.
                        </p>

                        <h3>5. Управление Cookie</h3>
                        <p>
                            Пользователь может удалить или заблокировать Cookie через настройки своего браузера.
                        </p>
                        <p>
                            Следует учитывать, что отключение технически необходимых Cookie может привести к невозможности авторизации и некорректной работе отдельных функций Сервиса.
                        </p>

                        <h3>6. Изменение Политики</h3>
                        <p>
                            Оператор вправе вносить изменения в настоящую Политику.
                        </p>
                        <p>
                            Актуальная редакция Политики всегда размещается на сайте Сервиса.
                        </p>

                        <h3>7. Контактная информация</h3>
                        <p>По вопросам использования Cookie Пользователь может обратиться:</p>
                        <ul>
                            <li><strong>Оператор:</strong> Коледина Антонина Владимировна</li>
                            <li><strong>Статус:</strong> Самозанятый</li>
                            <li><strong>E-mail:</strong> staff@insight-systems.ru</li>
                            <li><strong>Дата последнего обновления:</strong> 25.07.2026</li>
                        </ul>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}
